/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Full_Dog_GnawInputs */

const en_green_full_dog_gnaw = /** @type {(inputs: Green_Full_Dog_GnawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search segments...`)
};

const de_green_full_dog_gnaw = /** @type {(inputs: Green_Full_Dog_GnawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmente suchen...`)
};

/**
* | output |
* | --- |
* | "Search segments..." |
*
* @param {Green_Full_Dog_GnawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_full_dog_gnaw = /** @type {((inputs?: Green_Full_Dog_GnawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Full_Dog_GnawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_full_dog_gnaw(inputs)
	return de_green_full_dog_gnaw(inputs)
});